import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Popout menu rendered when the user clicks a calendar slot. Five action
 * buttons. The parent owns slot state, position, and the action callbacks;
 * this component is presentation only.
 *
 * The parent is responsible for outside-click dismissal — this component
 * doesn't manage its own visibility.
 */
export function ActionModal({
  open,
  slot,
  position,
  onAddMeetingOption,
  onCopy,
  onGmail,
  onGCal,
  onICal,
}) {
  const { t } = useTranslation();
  if (!open || !slot) return null;
  return (
    <div
      className="wv2-action-modal"
      style={{ position: 'absolute', top: position.y, left: position.x }}
      role="dialog"
      aria-label={t('actions.title')}
    >
      <button className="wv2-action-btn" onClick={onAddMeetingOption}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="12" y1="5" x2="12" y2="19" />
          <line x1="5" y1="12" x2="19" y2="12" />
        </svg>
        {t('actionModal.addMeetingOption')}
      </button>
      <button className="wv2-action-btn" onClick={onCopy}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
          <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
        </svg>
        {t('actions.copy')}
      </button>
      <button className="wv2-action-btn" onClick={onGmail}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
          <polyline points="22,6 12,13 2,6" />
        </svg>
        {t('actions.gmail')}
      </button>
      <button className="wv2-action-btn" onClick={onGCal}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
          <line x1="16" y1="2" x2="16" y2="6" />
          <line x1="8" y1="2" x2="8" y2="6" />
          <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
        {t('actions.googleCalendar')}
      </button>
      <button className="wv2-action-btn" onClick={onICal}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
          <line x1="16" y1="2" x2="16" y2="6" />
          <line x1="8" y1="2" x2="8" y2="6" />
          <line x1="3" y1="10" x2="21" y2="10" />
          <path d="M8 14h.01" />
          <path d="M12 14h.01" />
          <path d="M16 14h.01" />
          <path d="M8 18h.01" />
          <path d="M12 18h.01" />
          <path d="M16 18h.01" />
        </svg>
        {t('actions.icalInvite')}
      </button>
    </div>
  );
}
